<div class="modal-header">
  <div class="modal-title-wrapper">
    <h2 class="modal-title fw-bold">{{ 'manageEvent.orders.refundOrder' | translate }}</h2>
    <p class="text-muted mb-0 mt-2">{{ 'manageEvent.orderDetails.orderNum' | translate }} #{{ order.order_id }}</p>
  </div>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  <!-- Order Summary Card -->
  <div class="card bg-light mb-5">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          <span class="text-muted">{{ 'manageEvent.orders.customer' | translate }}:</span>
          <span class="fw-semibold ms-2">{{ order.user?.first_name }} {{ order.user?.last_name }}</span>
        </div>
        <div>
          <span class="text-muted">{{ 'manageEvent.orders.total' | translate }}:</span>
          <span class="fw-bold ms-2">{{ formatCents(order.total_cents) }} {{ order.currency }}</span>
        </div>
      </div>

      @if (hasPartialRefunds()) {
        <div class="alert alert-info mb-0">
          <div class="d-flex justify-content-between">
            <span>{{ 'manageEvent.orders.totalRefunded' | translate }}:</span>
            <span class="fw-bold">{{ formatCents(getTotalRefunded()) }} {{ order.currency }}</span>
          </div>
          <div class="d-flex justify-content-between mt-2">
            <span>{{ 'manageEvent.orders.remainingRefundable' | translate }}:</span>
            <span class="fw-bold">{{ formatCents(getRemainingRefundable()) }} {{ order.currency }}</span>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Refund History (if any) -->
  @if (order.refunds && order.refunds.length > 0) {
    <div class="mb-5">
      <h6 class="fw-bold mb-3">
        <i class="fa fa-history me-2 text-primary"></i>
        {{ 'manageEvent.orders.refundHistory' | translate }}
      </h6>
      <div class="table-responsive">
        <table class="table table-row-bordered table-sm mb-0">
          <thead class="bg-light">
            <tr class="text-muted fs-7">
              <th>{{ 'manageEvent.orders.date' | translate }}</th>
              <th class="text-end">{{ 'manageEvent.orders.amount' | translate }}</th>
              <th>{{ 'manageEvent.orders.reason' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (refund of order.refunds; track refund.refund_id) {
              <tr>
                <td class="text-muted">{{ formatDateTime(refund.created_at) }}</td>
                <td class="text-end fw-semibold">{{ formatCents(refund.amount_cents) }} {{ order.currency }}</td>
                <td class="text-muted">{{ refund.reason || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

  <!-- Refund Type Selection -->
  <div class="mb-5">
    <label class="form-label fw-bold">{{ 'manageEvent.orders.refundType' | translate }}</label>
    <div class="d-flex gap-4">
      <div class="form-check">
        <input class="form-check-input" type="radio" name="refundType" id="fullRefund"
          value="full" [(ngModel)]="refundType" (ngModelChange)="onRefundTypeChange()">
        <label class="form-check-label" for="fullRefund">
          {{ 'manageEvent.orders.fullRefund' | translate }}
          <span class="text-muted">({{ formatCents(getRemainingRefundable()) }} {{ order.currency }})</span>
        </label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" name="refundType" id="partialRefund"
          value="partial" [(ngModel)]="refundType" (ngModelChange)="onRefundTypeChange()">
        <label class="form-check-label" for="partialRefund">
          {{ 'manageEvent.orders.partialRefund' | translate }}
        </label>
      </div>
    </div>
  </div>

  <!-- Partial Refund Amount -->
  @if (refundType === 'partial') {
    <div class="mb-5">
      <label class="form-label fw-bold">{{ 'manageEvent.orders.refundAmount' | translate }}</label>
      <div class="input-group">
        <input type="number" class="form-control"
          [value]="formatCentsInput(refundAmountCents)"
          (input)="onAmountChange($any($event.target).value)"
          [min]="0.01"
          [max]="formatCentsInput(getRemainingRefundable())"
          step="0.01">
        <span class="input-group-text">{{ order.currency }}</span>
      </div>
      @if (!isAmountValid() && refundAmountCents > getRemainingRefundable()) {
        <div class="text-danger fs-7 mt-2">
          {{ 'manageEvent.orders.amountExceedsRemaining' | translate }}
        </div>
      }
      @if (!isAmountValid() && refundAmountCents <= 0) {
        <div class="text-danger fs-7 mt-2">
          {{ 'manageEvent.orders.amountMustBePositive' | translate }}
        </div>
      }
    </div>
  }

  <!-- Refund Reason -->
  <div class="mb-5">
    <label class="form-label fw-bold">{{ 'manageEvent.orders.refundReason' | translate }}</label>
    <textarea class="form-control" rows="3"
      [(ngModel)]="refundReason"
      [placeholder]="'manageEvent.orders.refundReasonPlaceholder' | translate"></textarea>
  </div>

  <!-- Warning -->
  <div class="alert alert-warning">
    <div class="d-flex">
      <i class="fa fa-exclamation-triangle text-warning me-3 fs-4"></i>
      <div>
        <div class="fw-bold">{{ 'manageEvent.orders.refundWarningTitle' | translate }}</div>
        <div class="text-muted">{{ 'manageEvent.orders.refundWarning' | translate }}</div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <app-button
    [variant]="'outline'"
    [label]="'common.cancel' | translate"
    (clicked)="close()"
  />
  <app-button
    [variant]="'danger'"
    [label]="'manageEvent.orders.processRefund' | translate"
    [iconClass]="'fa fa-rotate-left'"
    [loading]="processing"
    [disabled]="!canSubmit()"
    (clicked)="submitRefund()"
  />
</div>
